import Cookies from "js-cookie";
import moment from "jalali-moment";
import { isEmpty } from "lodash";

import {
  toastSuccessMessage,
  toastWarningMessage,
} from "./toastMessage/toastMessage";

//* Start Cookie
export const getCookies = (name) => {
  return Cookies.get(name);
};

export const removeCookies = (name, path = "/") => {
  return Cookies.remove(name, { path });
};

export const setCookies = (name, value, path = "/") => {
  return Cookies.set(name, value, { path, expires: 1000 });
};
//* Start Cookie

//* Start Number Utils
const numberToWords = (num) => {
  const units = ["", "یک", "دو", "سه", "چهار", "پنج", "شش", "هفت", "هشت", "نه"];
  const teens = [
    "ده",
    "یازده",
    "دوازده",
    "سیزده",
    "چهارده",
    "پانزده",
    "شانزده",
    "هفده",
    "هجده",
    "نوزده",
  ];
  const tens = [
    "",
    "ده",
    "بیست",
    "سی",
    "چهل",
    "پنجاه",
    "شصت",
    "هفتاد",
    "هشتاد",
    "نود",
  ];
  const hundreds = [
    "",
    "صد",
    "دویست",
    "سیصد",
    "چهارصد",
    "پانصد",
    "ششصد",
    "هفتصد",
    "هشتصد",
    "نهصد",
  ];
  const thousands = ["", "هزار", "میلیون", "میلیارد", "تریلیون"];

  function convertHundreds(n) {
    if (n === 0) return "";
    else if (n < 10) return units[n];
    else if (n < 20) return teens[n - 10];
    else if (n < 100)
      return (
        tens[Math.floor(n / 10)] + (n % 10 !== 0 ? " و " + units[n % 10] : "")
      );
    else
      return (
        hundreds[Math.floor(n / 100)] +
        (n % 100 !== 0 ? " و " + convertHundreds(n % 100) : "")
      );
  }

  function convertThousands(n, idx) {
    if (n === 0) return "";
    return convertHundreds(n) + " " + thousands[idx];
  }

  if (num === 0) return "صفر";

  let result = "";
  let idx = 0;

  while (num > 0) {
    if (num % 1000 !== 0) {
      const segment = convertThousands(num % 1000, idx);
      result = segment + (result ? " و " + result : "");
    }
    num = Math.floor(num / 1000);
    idx++;
  }

  return result.trim();
};

export const numberSeparate = (number) => {
  if (!number) return number;
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const removeNumberSeparate = (value) => {
  return value.replace(/\D/g, "");
};

export const convertNumberToWords = (number) => {
  const result = numberToWords(number);

  if (result === "undefined") return null;

  return numberToWords(number);
};

export const convertPercentNumber = (number) => {
  if (!number) return number;

  return Math.round(number * 100);
};
//* End Number Utils

//* Start Convert Number Utils
let persianNumbers = [
  /۰/g,
  /۱/g,
  /۲/g,
  /۳/g,
  /۴/g,
  /۵/g,
  /۶/g,
  /۷/g,
  /۸/g,
  /۹/g,
];
let arabicNumbers = [
  /٠/g,
  /١/g,
  /٢/g,
  /٣/g,
  /٤/g,
  /٥/g,
  /٦/g,
  /٧/g,
  /٨/g,
  /٩/g,
];
let englishNumbers = [
  /0/g,
  /1/g,
  /2/g,
  /3/g,
  /4/g,
  /5/g,
  /6/g,
  /7/g,
  /8/g,
  /9/g,
];

export const convertToArabicNumber = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
    }
  }
  return str;
};

export const convertToEnglishNumber = (str) => {
  if (typeof str === "string") {
    for (var i = 0; i < 10; i++) {
      str = str.replace(persianNumbers[i], i).replace(englishNumbers[i], i);
    }
  }
  return str;
};
//* End Convert Number Utils

//* Start Date Utils
export const formatToEnglishDate = (date, format = "jYYYY-jMM-jDD HH:mm") => {
  if (!date) return;
  return moment(date, format).toDate().toISOString();
};

export const convertDate = (
  date,
  format = "DD MMM YYYY ساعت HH:mm:ss",
  locale = "fa"
) => {
  if (!date) return "-";
  return moment(date).locale(locale).format(format);
};

export const convertDateShort = (
  date,
  format = "DD MMM YYYY",
  locale = "fa"
) => {
  if (!date) return "-";
  return moment(date).locale(locale).format(format);
};

export const getLocaleTime = (isObject) => {
  if (isObject) {
    const date = new Date();
    return {
      hour: date.getHours(),
      minutes: date.getMinutes(),
      seconds: date.getSeconds(),
    };
  } else {
    return new Date().getTime();
  }
};

export const isDateGreaterThanNow = (date, wait_type, wait_time) => {
  const userDate = moment(date, "jYYYY-jMM-jDD H:m:s").toDate().getTime();

  let unit = "m";
  switch (wait_type) {
    case 0:
      unit = "m";
      break;
    case 1:
      unit = "h";
      break;
    case 2:
      unit = "d";
      break;

    default:
      unit = "m";
      break;
  }

  const calcDate = moment().add(wait_time, unit).toDate().getTime();

  return userDate >= calcDate;
};

export const getLocaleDate = (
  isObject,
  locales = "fa-IR",
  options = { year: "numeric", month: "2-digit", day: "2-digit" }
) => {
  if (isObject) {
    const date = convertToEnglishNumber(
      new Date().toLocaleDateString(locales, options)
    ).split("/");

    return { year: date[0], month: date[1], day: date[2] };
  } else {
    return convertToEnglishNumber(
      new Date().toLocaleDateString(locales, options)
    );
  }
};

export const getFutureDate = (
  day,
  locales = "fa-IR",
  options = { year: "numeric", month: "2-digit", day: "2-digit" }
) => {
  const date = new Date();
  date.setDate(date.getDate() + day);
  const splitDate = convertToEnglishNumber(
    date.toLocaleDateString(locales, options)
  ).split("/");
  return { year: splitDate[0], month: splitDate[1], day: splitDate[2] };
};

export const getCustomCalendarDate = (
  date,
  separator = "-",
  isZero = false
) => {
  if (!date) return "";
  return date.toISOString();
  // return `${date.year}${separator}${
  //   String(date.month)?.length === 1 && isZero ? "0" : ""
  // }${date.month}${separator}${
  //   String(date.day).length === 1 && isZero ? "0" : ""
  // }${date.day}`;
};

export const getCustomCalendarDateTime = (
  date,
  separator = "-",
  isZero = true
) => {
  if (!date) return "";

  return `${date.year}${separator}${
    String(date.month)?.length === 1 && isZero ? "0" : ""
  }${date.month}${separator}${
    String(date.day).length === 1 && isZero ? "0" : ""
  }${date.day} ${String(date.hour)?.length === 1 && isZero ? "0" : ""}${
    date.hour
  }:${String(date.minute).length === 1 && isZero ? "0" : ""}${date.minute}:00`;
};

export const separateScheduleTime = (schedule, isObject) => {
  const scheduleSplited = (schedule ?? "1396-01-01 24:00:00")?.split(" ");

  let time = scheduleSplited[1]?.split(":")[0];
  let date = scheduleSplited[0];

  if (isObject) return { date, time };
  return `${date} ${time}`;
};

export const generateUniqueString = (prefix) =>
  `${prefix}${Date.now()}-${Math.random().toString(36).substring(2, 9)}`;
//* End Date Utils

//* Start Validation
export const isValidPhoneNumber = (phoneNumber) => {
  return /^(\+98|0)?9\d{9}$/.test(phoneNumber);
};

export const isValidEmail = (email) => {
  return /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i.test(
    email
  );
};
export const handleCheckPersianNumberInput = (event) => {
  if (event.target.tagName === "INPUT" && event.target.type === "text") {
    const persianToEnglishNumbers = {
      "۰": "0", // Persian
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
      "٠": "0", // Arabic
      "١": "1",
      "٢": "2",
      "٣": "3",
      "٤": "4",
      "٥": "5",
      "٦": "6",
      "٧": "7",
      "٨": "8",
      "٩": "9",
    };

    const persianArabicNumberPattern = /[۰-۹٠-٩]/g; // Covers both Persian and Arabic numbers
    const value = event.target.value;

    if (persianArabicNumberPattern.test(value)) {
      const convertedValue = value.replace(
        persianArabicNumberPattern,
        (match) => persianToEnglishNumbers[match]
      );
      event.target.value = convertedValue;
    }
  }
};
//* End Validation

//* Start Default Picture
export const defaultPicture =
  "data:image/jpeg;base64,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";

export const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
};
//* End Default Picture

//* Start Map
export const mapBoxAccessToken =
  "pk.eyJ1IjoiZG5hLWgiLCJhIjoiY2p2eGN3ZG1lMDNpcTQ0cnpvMHBobm5ubSJ9.anMU_gz8N2Hl7H0oTgtINg";
export const initialViewState = {
  latitude: 27.2022047,
  longitude: 56.3158316,
  zoom: 15,
};
//* End Map

//* Start Order
export const canCancelOrder = [0, 1, 2, 3, 4, 5, 7];
//* End Order

//* Start Service
export const serviceParameters = [
  "عدد",
  "سوییچ",
  "تاریخ،زمان",
  "متن",
  "لیست کشویی",
  "آپلود عکس",
  "تاریخ",
  "زمان",
  "لیست تک گزینه ای",
  "آیتم",
];
//* End Service

//* Start Rate
export const rateType = (type) => {
  switch (type) {
    case 1:
      return "خیلی ضعیف";
    case 2:
      return "ضعیف";
    case 3:
      return "متوسط";
    case 4:
      return "خوب";
    case 5:
      return "راضی";

    default:
      return "";
  }
};
//* End Rate

//* Start Hichestan Date Picker
export const dialogContainerStyle = {
  "--datepicker-color": "#646464",
  "--datepicker-button-hover-color": "#646464",
};
//* End Hichestan Date Picker

//* Start URL
export const baseRoute = (isOrgan, route) =>
  (isOrgan ? baseOrganURL : baseAdminURL) + route;

// Admin Url
export const baseAdminURL = "/ADM";
export const baseAdminRoute = (route) => baseAdminURL + route;

// Organ Url
export const baseOrganURL = "/ORG";
export const baseOrganRoute = (route) => baseOrganURL + route;
//* End URL

//* Start Personnel
export const activityTypeItems = [
  "در لیست تسویه",
  "تسویه شده",
  "فعال",
  "غیرفعال انسانی",
  "غیرفعال حسابداری",
];
export const expertTypeItems = [
  "متخصص A",
  "متخصص B",
  "متخصص C",
  "متخصص D",
  "متخصص E",
];
export const referralSourceItems = [
  "دیوار",
  "همکار متخصص",
  "حضوری",
  "فنی و حرفه ای",
  "پیک و خیابان",
  "اینستاگرام",
  "واتساپ",
  "کارگاه ها",
  "شرکت ها",
];
export const finalResultItems = [
  "قرارداد بست",
  "آمد ولی قرارداد نبست",
  "آمد گفت برمیگردم",
  "پشت تلفن گفت همکاری نمیکنم",
  "خودمون کنسلش کردیم",
];
export const preliminaryResultItems = [
  "اوکی شد",
  "تلفن را قطع کرد",
  "تمایل به همکاری ندارد",
  "بندرعباس نبود",
  "کلا کنسل است",
  "پاسخگو نبود",
  "خاموش بود",
  "میاد شرکت",
  "خبر میدهند",
];

export const personnelTypeButton = (isSpecial, setIsSpecial) => {
  return (
    <button
      type="button"
      className={`btn btn-${
        isSpecial === "All"
          ? "info"
          : isSpecial === true
          ? "primary"
          : "secondary"
      }`}
      onClick={() => {
        setIsSpecial(
          isSpecial === "All" ? true : isSpecial === true ? false : "All"
        );
      }}
    >
      {isSpecial === "All" ? "همه" : isSpecial === true ? "ویژه" : "عادی"}
    </button>
  );
};
//* End Personnel

//* Start Clipboard
export const writeToClipboard = (text) => {
  if (navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      toastSuccessMessage("کپی با موفقیت انجام شد");
    });
  } else {
    toastWarningMessage("مرورگر شما از کپی پشتیبانی نمی کند");
  }
};
//* End Clipboard

//* Start Payment
export const paymentStatusItems = [
  "تراکنش ناموفق",
  "منتظر تایید",
  "تراکنش ناموفق",
  "تراکنش ناموفق",
  "تراکنش موفق",
  "تراکنش ناموفق",
  "تراکنش موفق",
  "تراکنش موفق",
];
//* End Payment

//* Start Display Mode
export const displayModeItems = ["LIST", "CARD"];

export const displayModeToText = (type) => {
  switch (type) {
    case displayModeItems[0]:
      return "لیستی";
    case displayModeItems[1]:
      return "شبکه ای";
    default:
      return "";
  }
};
//* End Display Mode

//* Start Convert To CSV Data
export const convertDataToCSV = (items, type, config) => {
  let headers = [],
    data = [];

  switch (type) {
    // Orders
    case "orders":
      headers = [
        { label: "نوع سفارش", key: "service" },
        { label: "تاریخ", key: "schedule_time.date" },
        { label: "زمان", key: "schedule_time.time" },
        { label: "کدپیگیری", key: "ref_num" },
        { label: "نام و نام خانوادگی مشتری", key: "full_name" },
        { label: "شماره موبایل مشتری", key: "mobile" },
        { label: "سازمان مشتری", key: "employer_name" },
        { label: "نام پرسنل", key: "personnel" },
        { label: "نوع سفارش", key: "need_special_personnel" },
        { label: "T/S/C", key: "T/S/C" },
        { label: "وضعیت", key: "status" },
      ];
      data = items.map((_item) => ({
        service: _item.service,
        "schedule_time.date": separateScheduleTime(_item.schedule_time, true)
          ?.date,
        "schedule_time.time": separateScheduleTime(_item.schedule_time, true)
          ?.time,
        ref_num: _item?.ref_num,
        full_name: `${_item?.client?.first_name} ${_item?.client?.last_name}`,
        mobile: _item?.client?.mobile,
        employer_name: _item?.client?.employer
          ? _item?.client?.employer?.name
          : "کاربر عادی",
        personnel:
          !isEmpty(_item?.personnel) &&
          _item?.personnel?.map(
            (_personnelVal) =>
              `${_personnelVal?.first_name} ${_personnelVal?.last_name} - ${
                _personnelVal?.mobile ?? "ندارد"
              }, `
          ),
        need_special_personnel: _item?.need_special_personnel ? "ویژه" : "عادی",
        "T/S/C": `${_item?.total}/${_item?.successful}/${_item?.this}`,
        status:
          config?.STATUS_CHOICES &&
          _item?.status >= 0 &&
          config?.STATUS_CHOICES[_item?.status],
      }));
      break;
    // Employees
    case "employees":
      headers = [
        { label: "سمت", key: "post" },
        { label: "کد اختصاصی", key: "employee_code" },
        { label: "ورود سازمانی", key: "isLogin" },
        { label: "نام", key: "first_name" },
        { label: "نام خانوادگی", key: "last_name" },
        { label: "شماره موبایل", key: "mobile" },
        { label: "کل", key: "all" },
        { label: "نظافت", key: "cleaning" },
        { label: "اسباب کشی", key: "moving" },
        { label: "کارواش", key: "carwash" },
        { label: "لوازم خانگی", key: "appliance" },
        { label: "خشکشویی", key: "dc" },
        { label: "کولرگازی", key: "ac" },
        { label: "قالیشویی", key: "carpet" },
        { label: "سایر", key: "order_count" },
      ];
      data = items.map((_item) => {
        const isLogin = !isEmpty(_item?.user);
        return {
          post: _item?.post,
          employee_code: _item?.employee_code,
          isLogin: isLogin ? "✓" : "✕",
          first_name: isLogin ? _item?.user?.first_name : "-",
          last_name: isLogin ? _item?.user?.last_name : "-",
          mobile: isLogin ? _item?.user?.mobile : "-",
          all: isLogin ? _item?.user?.order_count?.all : "-",
          cleaning: isLogin ? _item?.user?.order_count?.cleaning : "-",
          moving: isLogin ? _item?.user?.order_count?.moving : "-",
          carwash: isLogin ? _item?.user?.order_count?.carwash : "-",
          appliance: isLogin ? _item?.user?.order_count?.appliance : "-",
          dc: isLogin ? _item?.user?.order_count?.dc : "-",
          ac: isLogin ? _item?.user?.order_count?.ac : "-",
          carpet: isLogin ? _item?.user?.order_count?.carpet : "-",
          order_count: isLogin ? config(_item?.user?.order_count) : "-",
        };
      });
      break;
    // Statistics
    case "statistics":
      headers = [
        { label: "نام", key: "first_name" },
        { label: "نام خانوادگی", key: "last_name" },
        { label: "شماره موبایل", key: "mobile" },
        { label: "تعداد سفارشات", key: "order_count" },
      ];
      data = items.map((_item) => {
        return {
          first_name: _item.user?.first_name,
          last_name: _item?.user?.last_name,
          mobile: _item?.user?.mobile,
          order_count: numberSeparate(_item?.user?.order_count.all),
        };
      });
      break;

    default:
      break;
  }

  return { data, headers, fileName: type };
};
//* End Convert To CSV Data

//* Start Hex
export const getRandomHexColor = () => {
  const letters = "0123456789ABCDEF";
  let color = "#";
  for (let i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};
//* End Hex

//* Start Notification
export const notificationTypeItems = ["SUCCESS", "ERROR", "INFO", "WARNING"];

export const playNotificationSound = async () => {
  let soundName = "/assets/sound/notification.mp3";

  const audio = new Audio(soundName);

  try {
    await audio.play();
  } catch (error) {
    // error
  }
};
//* End Notification

//* Start Progress
export const orderProgressToText = (type) => {
  let result = "";
  switch (type) {
    case 0:
      result = "ثبت شده";
      break;
    case 50:
      result = "هماهنگ شده";
      break;
    case 75:
      result = "درحال انجام";
      break;
    case 90:
      result = "خاتمه یافته";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
export const orderProgressToColor = (type) => {
  let result = "";
  switch (type) {
    case 0:
      result = "warning";
      break;
    case 50:
      result = "info";
      break;
    case 75:
      result = "primary";
      break;
    case 90:
      result = "success";
      break;

    default:
      result = type;
      break;
  }
  return result;
};
//* End Progress

//* Start File
export const validateFile = (file) => {
  if (!file) return;

  const maxSize = 3;
  const allowedExtensions = [
    ".jpg",
    ".jpeg",
    ".png",
    ".gif",
    ".docx",
    ".xlsx",
    ".csv",
    ".pdf",
    ".mp4",
    ".avi",
  ];
  const fileExtension = file.name.split(".").pop();
  if (!allowedExtensions.includes(`.${fileExtension.toLowerCase()}`))
    return "پسوند فایل مورد نظر مجاز نمی باشد";
  if (file.size > maxSize * 1024 * 1024)
    return `حجم فایل نمی تواند بیشتر از ${maxSize} مگابایت باشد`;
};
//* End File

//* Start Permission
export const adminPermissionItems = [0, 500, 600, 700, 800, 900, 1000];

export const convertAdminPermissionToText = (type) => {
  let value = "";
  switch (type) {
    case adminPermissionItems[0]:
      value = "معمولی";
      break;
    case adminPermissionItems[1]:
      value = "پشتیبان";
      break;
    case adminPermissionItems[2]:
      value = "امور مشتریان";
      break;
    case adminPermissionItems[3]:
      value = "جذب";
      break;
    case adminPermissionItems[4]:
      value = "حسابدار";
      break;
    case adminPermissionItems[5]:
      value = "مدیر";
      break;
    case adminPermissionItems[6]:
      value = "مدیر اصلی";
      break;

    default:
      break;
  }
  return value;
};
//* End Permission

export const checkCityLimits = (lat, lng, city) => {
  // Fail open: If the admin hasn't drawn a polygon for this city yet, allow it.
  if (!city?.polygon || !Array.isArray(city.polygon) || city.polygon.length < 3) {
    return;
  }

  const x = Number(lng);
  const y = Number(lat);
  let isInside = false;

  const polygon = city.polygon;
  
  // Standard Ray-Casting Algorithm
  for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
    const xi = polygon[i][0];
    const yi = polygon[i][1];
    const xj = polygon[j][0];
    const yj = polygon[j][1];

    const intersect = ((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
    
    if (intersect) {
      isInside = !isInside;
    }
  }

  if (!isInside) {
    // Fire your UI warning here
    toastWarningMessage(`مکان انتخابی خارج از مرزهای ${city.name || 'شهر'} قرار دارد.`);
  }
};
